import React from 'react';
import { Carousel } from 'react-bootstrap';
import { Fade, Slide, Zoom, AttentionSeeker } from 'react-awesome-reveal';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

import AZ from '../../assets/images/Per11.png';
import AZ2 from '../../assets/logos/logo2.png'; // Import de la deuxième image
import AZ3 from '../../assets/images/Per2.png'; // Import de la deuxième image
import AZ4 from '../../assets/images/hola.png'; // Import de la deuxième image
import bg1 from '../../assets/images/banner/bg1.jpg';
import AZ5 from '../../assets/images/Per14.png';

import './Banner.css';

const Banner = () => {
  const slideStyle = (bg) => ({
    backgroundImage: `url(${bg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '850px',
    position: 'relative',
    color: '#fff',
  });

  const overlayStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.55)',
    zIndex: 1,
  };

  const contentStyle = {
    zIndex: 2,
    position: 'relative',
  };

  // Variantes d'animation pour les images
  const imageVariants = {
    float: {
      y: [0, -20, 0],
      transition: {
        duration: 4,
        repeat: Infinity,
        ease: "easeInOut"
      }
    },
    floatReverse: {
      y: [0, 20, 0],
      transition: {
        duration: 5,
        repeat: Infinity,
        ease: "easeInOut"
      }
    }
  };

  return (
    <Carousel fade controls indicators interval={6000} pause={false}>
        <Carousel.Item>
        <div style={slideStyle(bg1)} className="banner-carousel-item">
          <div style={overlayStyle}></div>

          <div className="slider-content d-flex justify-content-center align-items-center h-100 text-center" style={contentStyle}>
            <div className="particles">
              {[...Array(20)].map((_, i) => (
                <div 
                  key={i}
                  className="particle"
                  style={{
                    width: `${Math.random() * 10 + 2}px`,
                    height: `${Math.random() * 10 + 2}px`,
                    top: `${Math.random() * 100}%`,
                    left: `${Math.random() * 100}%`,
                    animationDelay: `${Math.random() * 5}s`,
                    animationDuration: `${Math.random() * 10 + 5}s`
                  }}
                />
              ))}
            </div>
            
            <div className="position-relative">
              {/* Conteneur pour les deux images */}
              <div className="d-flex justify-content-center align-items-center position-relative">

             
                {/* Image principale */}
               <Zoom triggerOnce>
                  <motion.div
                    variants={imageVariants}
                   
                    className="position-relative z-10"
                  >
                    <img
                      src={AZ2}
                      alt="Logo AZ"
                      className="img-fluid"
                      style={{ width: '400px', maxWidth: '90%', filter: 'drop-shadow(0 15px 25px rgba(0, 0, 0, 0.7))' }}
                    />
                  </motion.div>
                </Zoom>
                
                {/* Deuxième image avec animation continue */}
             
              </div>

              {/* Texte superposé */}
              <div className="text-overlay position-absolute top-50 start-50 translate-middle text-white w-100">
            
                
             
              </div>
            </div>
          </div>
        </div>
      </Carousel.Item>

        <Carousel.Item>
        <div style={slideStyle(bg1)} className="banner-carousel-item">
          <div style={overlayStyle}></div>

          <div className="slider-content d-flex justify-content-center align-items-center h-100 text-center" style={contentStyle}>
            <div className="particles">
              {[...Array(20)].map((_, i) => (
                <div 
                  key={i}
                  className="particle"
                  style={{
                    width: `${Math.random() * 10 + 2}px`,
                    height: `${Math.random() * 10 + 2}px`,
                    top: `${Math.random() * 100}%`,
                    left: `${Math.random() * 100}%`,
                    animationDelay: `${Math.random() * 5}s`,
                    animationDuration: `${Math.random() * 10 + 5}s`
                  }}
                />
              ))}
            </div>
            
            <div className="position-relative">
              {/* Conteneur pour les deux images */}
              <div className="d-flex justify-content-center align-items-center position-relative">
                {/* Image principale */}
                <Zoom triggerOnce>
                  <motion.div
                    variants={imageVariants}
                   
                    className="position-relative z-10"
                  >
                    <img
                      src={AZ5}
                      alt="Logo AZ"
                      className="img-fluid"
                      style={{ width: '850px', maxWidth: '90%', filter: 'drop-shadow(0 15px 25px rgba(0, 0, 0, 0.7))' }}
                    />
                  </motion.div>
                </Zoom>
                
                {/* Deuxième image avec animation continue */}
                <motion.div
                  className="position-absolute"
                  style={{ right: '-10%', top: '15%', zIndex: 5 }}
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ 
                    opacity: 1, 
                    scale: 1,
                    rotate: [0, 5, -5, 0],
                  }}
                  transition={{
                    delay: 0.5,
                    duration: 1,
                    rotate: {
                      duration: 8,
                      repeat: Infinity,
                      repeatType: "reverse",
                      ease: "easeInOut"
                    }
                  }}
                  variants={imageVariants}
                
                >
                  <img
                    src={AZ2}
                    alt="Détail supplémentaire"
                    className="img-fluid"
                    style={{ 
                      width: '350px', 
                      maxWidth: '40%',
                      filter: 'drop-shadow(0 10px 20px rgba(0, 0, 0, 0.5))',
                      animation: 'pulse 4s infinite alternate'
                    }}
                  />
                </motion.div>
              </div>

              {/* Texte superposé */}
              <div className="text-overlay position-absolute top-50 start-50 translate-middle text-white w-100">
                <Slide direction="down" triggerOnce>
                  <h1 className="slide-title gold-text lh-1">RESTEZ SEREIN. <br /> ON VEILLE</h1>
                </Slide>
                <AttentionSeeker effect="pulse" delay={300} triggerOnce>
                  <h4 className="mt-2 text-white">Protéger aujourd’hui, garantir demain.</h4>
                </AttentionSeeker>
                <Fade delay={500} triggerOnce>
                  <div className="mt-4">
                    <Link to="/Services" className="btn btn-warning me-2">Nos Services</Link>
                    <Link to="/Contact" className="btn btn-outline-light">Contactez-Nous</Link>
                  </div>
                </Fade>
              </div>
            </div>
          </div>
        </div>
      </Carousel.Item>
      
      <Carousel.Item>
        <div style={slideStyle(bg1)} className="banner-carousel-item">
          <div style={overlayStyle}></div>

          <div className="slider-content d-flex justify-content-center align-items-center h-100 text-center" style={contentStyle}>
            <div className="particles">
              {[...Array(20)].map((_, i) => (
                <div 
                  key={i}
                  className="particle"
                  style={{
                    width: `${Math.random() * 10 + 2}px`,
                    height: `${Math.random() * 10 + 2}px`,
                    top: `${Math.random() * 100}%`,
                    left: `${Math.random() * 100}%`,
                    animationDelay: `${Math.random() * 5}s`,
                    animationDuration: `${Math.random() * 10 + 5}s`
                  }}
                />
              ))}
            </div>
            
            <div className="position-relative">
              {/* Conteneur pour les deux images */}
              <div className="d-flex justify-content-center align-items-center position-relative">
                {/* Image principale */}
                <Zoom triggerOnce>
                  <motion.div
                    variants={imageVariants}
                   
                    className="position-relative z-10"
                  >
                    <img
                      src={AZ}
                      alt="Logo AZ"
                      className="img-fluid"
                      style={{ width: '600px', maxWidth: '90%', filter: 'drop-shadow(0 15px 25px rgba(0, 0, 0, 0.7))' }}
                    />
                  </motion.div>
                </Zoom>
                
                {/* Deuxième image avec animation continue */}
                <motion.div
                  className="position-absolute"
                  style={{ right: '-10%', top: '15%', zIndex: 5 }}
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ 
                    opacity: 1, 
                    scale: 1,
                    rotate: [0, 5, -5, 0],
                  }}
                  transition={{
                    delay: 0.5,
                    duration: 1,
                    rotate: {
                      duration: 8,
                      repeat: Infinity,
                      repeatType: "reverse",
                      ease: "easeInOut"
                    }
                  }}
                  variants={imageVariants}
                
                >
                  <img
                    src={AZ2}
                    alt="Détail supplémentaire"
                    className="img-fluid"
                    style={{ 
                      width: '350px', 
                      maxWidth: '40%',
                      filter: 'drop-shadow(0 10px 20px rgba(0, 0, 0, 0.5))',
                      animation: 'pulse 4s infinite alternate'
                    }}
                  />
                </motion.div>
              </div>

              {/* Texte superposé */}
              <div className="text-overlay position-absolute top-50 start-50 translate-middle text-white w-100">
                <Slide direction="down" triggerOnce>
                  <h1 className="slide-title gold-text lh-1">Votre sécurité, notre priorité.</h1>
                </Slide>
                <AttentionSeeker effect="pulse" delay={300} triggerOnce>
                  <h4 className="mt-2 text-white">Protéger aujourd’hui, garantir demain.</h4>
                </AttentionSeeker>
                <Fade delay={500} triggerOnce>
                  <div className="mt-4">
                    <Link to="/Services" className="btn btn-warning me-2">Nos Services</Link>
                    <Link to="/Contact" className="btn btn-outline-light">Contactez-Nous</Link>
                  </div>
                </Fade>
              </div>
            </div>
          </div>
        </div>
      </Carousel.Item>
            <Carousel.Item>
        <div style={slideStyle(bg1)} className="banner-carousel-item">
          <div style={overlayStyle}></div>

          <div className="slider-content d-flex justify-content-center align-items-center h-100 text-center" style={contentStyle}>
            <div className="particles">
              {[...Array(20)].map((_, i) => (
                <div 
                  key={i}
                  className="particle"
                  style={{
                    width: `${Math.random() * 10 + 2}px`,
                    height: `${Math.random() * 10 + 2}px`,
                    top: `${Math.random() * 100}%`,
                    left: `${Math.random() * 100}%`,
                    animationDelay: `${Math.random() * 5}s`,
                    animationDuration: `${Math.random() * 10 + 5}s`
                  }}
                />
              ))}
            </div>
            
            <div className="position-relative">
              {/* Conteneur pour les deux images */}
              <div className="d-flex justify-content-center align-items-center position-relative">
                {/* Image principale */}
                <Zoom triggerOnce>
                  <motion.div
                    variants={imageVariants}
                   
                    className="position-relative z-10"
                  >
                    <img
                      src={AZ4}
                      alt="Logo AZ"
                      className="img-fluid"
                      style={{ width: '1600px', maxWidth: '90%', filter: 'drop-shadow(0 15px 25px rgba(0, 0, 0, 0.7))' }}
                    />
                  </motion.div>
                </Zoom>
                
                {/* Deuxième image avec animation continue */}
                <motion.div
                  className="position-absolute"
                  style={{ right: '-10%', top: '15%', zIndex: 5 }}
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ 
                    opacity: 1, 
                    scale: 1,
                    rotate: [0, 5, -5, 0],
                  }}
                  transition={{
                    delay: 0.5,
                    duration: 1,
                    rotate: {
                      duration: 8,
                      repeat: Infinity,
                      repeatType: "reverse",
                      ease: "easeInOut"
                    }
                  }}
                  variants={imageVariants}
                
                >
                  <img
                    src={AZ2}
                    alt="Détail supplémentaire"
                    className="img-fluid"
                    style={{ 
                      width: '350px', 
                      maxWidth: '40%',
                      filter: 'drop-shadow(0 10px 20px rgba(0, 0, 0, 0.5))',
                      animation: 'pulse 4s infinite alternate'
                    }}
                  />
                </motion.div>
              </div>

              {/* Texte superposé */}
              <div className="text-overlay position-absolute top-50 start-50 translate-middle text-white w-100">
                <Slide direction="down" triggerOnce>
                  <h1 className="slide-title gold-text"> La vigilance qui inspire confiance.</h1>
                </Slide>
                <AttentionSeeker effect="pulse" delay={300} triggerOnce>
                  <h4 className="mt-2 text-white">Sécuriser, servir, rassurer.</h4>
                </AttentionSeeker>
                <Fade delay={500} triggerOnce>
                  <div className="mt-4">
                    <Link to="/Services" className="btn btn-warning me-2">Nos Services</Link>
                    <Link to="/Contact" className="btn btn-outline-light">Contactez-Nous</Link>
                  </div>
                </Fade>
              </div>
            </div>
          </div>
        </div>
      </Carousel.Item>
       <Carousel.Item>
        <div style={slideStyle(bg1)} className="banner-carousel-item">
          <div style={overlayStyle}></div>

          <div className="slider-content d-flex justify-content-center align-items-center h-100 text-center" style={contentStyle}>
            <div className="particles">
              {[...Array(20)].map((_, i) => (
                <div 
                  key={i}
                  className="particle"
                  style={{
                    width: `${Math.random() * 10 + 2}px`,
                    height: `${Math.random() * 10 + 2}px`,
                    top: `${Math.random() * 100}%`,
                    left: `${Math.random() * 100}%`,
                    animationDelay: `${Math.random() * 5}s`,
                    animationDuration: `${Math.random() * 10 + 5}s`
                  }}
                />
              ))}
            </div>
            
            <div className="position-relative">
              {/* Conteneur pour les deux images */}
              <div className="d-flex justify-content-center align-items-center position-relative">

             
                {/* Image principale */}
                <Slide direction='left'>
                  <motion.div
                    variants={imageVariants}
                   
                    className="position-relative z-10"
                  >
                    <img
                      src={AZ3}
                      alt="Logo AZ"
                      className="img-fluid"
                      style={{ width: '600px', maxWidth: '90%', filter: 'drop-shadow(0 15px 25px rgba(0, 0, 0, 0.7))' }}
                    />
                  </motion.div>
                </Slide>
                
                {/* Deuxième image avec animation continue */}
             
              </div>

              {/* Texte superposé */}
              <div className="text-overlay position-absolute top-50 start-50 translate-middle text-white w-100">
                <Slide direction="down" triggerOnce>
                  <h1 className="slide-title gold-text lh-1">Partout où vous êtes, nous veillons.</h1>
                </Slide>
                <AttentionSeeker effect="pulse" delay={300} triggerOnce>
                  <h4 className="mt-2 text-white">L’expertise au cœur de la protection.</h4>
                </AttentionSeeker>
                <Fade delay={500} triggerOnce>
                  <div className="mt-4">
                    <Link to="/Services" className="btn btn-warning me-2">Nos Services</Link>
                    <Link to="/Contact" className="btn btn-outline-light">Contactez-Nous</Link>
                  </div>
                </Fade>
              </div>
            </div>
          </div>
        </div>
      </Carousel.Item>
    </Carousel>
  );
};

export default Banner;